// Amount of customer's active orders on orders-history page
export const MAX_ACTIVE_ORDERS = 10

export const DEFAULT_ORDER_TABLE_SIZE = 5

export const MAX_ORDERS_REQ_LIMIT = 20

export const ORDER_STATUS = {
  CREATED: 'created',
  NEW: 'new',
  OPEN: 'open',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  REPLACED: 'replaced',
  FAILED: 'failed',
} as const

export const ORDER_UI_STATUS = {
  PREPARING_FOR_DISPATCH: 'Preparing for Dispatch',
  COMPLETED: 'Completed',
  PROCESSED: 'Order processed',
  PICKED: 'Order picked',
  PLACED: 'Order placed',
  CANCELLED: 'Cancelled',
  REFUNDED: 'Refunded',
  PARTIALLY_REFUNDED: 'Partially Refunded',
  OUT_FOR_DELIVERY: 'Out for Delivery',
  DELIVERED: 'Delivered',
  DELIVERY_UNSUCCESSFUL: 'Delivery Unsuccessful',
  ORDERED: 'Ordered',
  UNAVAILABLE: 'Unavailable',
  SUBSTITUTED: 'Substituted'
} as const

export const ORDER_REFUND_STATUS = {
  NOT_REFUNDED: 0,
  REFUNDED: 1,
  PARTIAL_REFUND: 2,
} as const

export const ORDER_DELIVERY_STATUS = {
  PLACED: 'PLACED',
  PROCESSED: 'PROCESSED',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
} as const

export const PAYMENT_SUMMARY_TYPES = {
  PREBOOK_DELIVERY: 'Pre-book Delivery',
  TOTAL: 'Total',
  SUBTOTAL: 'Subtotal',
  PROMOTIONAL_DISCOUNT: 'Promotional Discount',
  BASKET_TOTAL: 'Basket total',
  DELIVERY: 'Delivery',
  SMALL_BASKET_FEE: 'Small Basket Fee'
} as const

